<template>
  <div
    class="appointment-data-card-skeleton"
    :style="{ height: `${height}px` }"
  >
    <v-skeleton-loader
      v-if="!withoutAvatar"
      type="avatar"
      class="flex-shrink-0 mr-4"
      :width="width"
      :height="height"
    />
    <v-skeleton-loader
      class="my-auto w-100"
      type="text@2"
    />
  </div>
</template>

<script>
export default {
  name: 'AppointmentDataCardSkeleton',
  props: {
    width: {
      type: [String, Number],
      default: 80,
    },
    height: {
      type: [String, Number],
      default: 80,
    },
    withoutAvatar: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.appointment-data-card-skeleton {
  display: flex;

  &::v-deep .v-skeleton-loader {
    &__avatar {
      width: 100%;
      height: 100%;
    }

    &__text {
      $margin-y-first-child: 2px;
      $margin-y-last-child: 3px;

      border-radius: $border-radius-md;

      &:first-child {
        height: 16px;
        margin-top: $margin-y-first-child;
        margin-bottom: $margin-y-first-child + $margin-y-last-child;
      }

      &:last-child {
        height: 14px;
        margin-bottom: $margin-y-last-child;
      }
    }
  }
}
</style>
